import { Skeleton } from '@/components/ui/skeleton';

export default function LoaderGridTimeTurn() {
    return (
        <>
            <div className="flex gap-2">
                <Skeleton className="!rounded-md w-14 h-6 md:w-20 md:h-8" />
                <Skeleton className="!rounded-md w-14 h-6 md:w-20 md:h-8" />
                <Skeleton className="!rounded-md w-14 h-6 md:w-20 md:h-8" />
                <Skeleton className="!rounded-md w-14 h-6 md:w-20 md:h-8" />
                <Skeleton className="!rounded-md w-14 h-6 md:w-20 md:h-8" />
            </div>
        </>
    );
}
